import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function AdminUserActiveTabReducer(
	state = initialState.adminUserActiveTab,
	action
) {
	switch (action.type) {
		case types.SET_ADMIN_USER_ACTIVE_TAB: {
			return action.tab;
		}
		default:
			return state;
	}
}
